<template>
  <v-container>
    <v-checkbox
      v-model="value.is_interpolate_preset"
      :label="`Интерполировать реанализ по территории`"
      dense
    ></v-checkbox>
    <v-checkbox
      v-model="value.is_interpolate_point"
      :label="`Интерполировать реанализ в точку`"
      dense
    ></v-checkbox>
    <wapi-date-picker v-model="value.available_from" :label="`Доступно с`"></wapi-date-picker>
    <wapi-date-picker v-model="value.available_to" :label="`Доступно по`"></wapi-date-picker>
    <wapi-select-list v-model="value.parameters" :items="parameters" />
  </v-container>
</template>

<script>
import WapiSelectList from "../../../components/WapiSelectList.vue";
import WapiDatePicker from "../../../components/WapiDatePicker.vue";

export default {
  name: "ReanalysisSettings",
  components: {
    WapiSelectList,
    WapiDatePicker
  },
  props: {
    value: Object,
    parameters: Array
  },
  computed: {
    checkAll: {
      get: function() {
        if (this.model.parameters.length) {
          return !this.model.some(x => !x.checked);
        }

        return false;
      },
      set: function(value) {
        this.model.forEach(x => (x.checked = value));
      }
    }
  }
};
</script>